export default __webpack_public_path__ + "assets/images/d7efb4a638eea65046a833998196d3a0.png";